import React from "react";
import PropTypes from "prop-types";

import { makeStyles, Typography, Paper, Button } from "@material-ui/core";

// import { getBalanceAndSymbol } from "../ethereumFunctions";

import useIcon from "../hooks/useIcon";
// import { getTotalInvest } from "../Invest/InvestFunctions";

const useStyles = makeStyles((theme) => ({
  paperContainer: {
    borderRadius: theme.spacing(2),
    width: "100%",
    height: "100%",
    padding: theme.spacing(2),
    display: "flex",
    flexFlow: "column",
    backgroundColor: theme.palette.background.default,
    position: "relative",
  },

  itemHeader: {
    display: "flex",
    alignItems: "start",
    marginBottom: theme.spacing(1),
    gap: theme.spacing(1),
  },
  imageHolder: {
    width: "50px",
    height: "50px",
  },
  imageHolderInner: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  itemName: {
    lineHeight: "1",
    fontWeight: "700",
    marginTop: theme.spacing(1) / 2,
    marginBottom: theme.spacing(1) / 2,
    color: theme.palette.primary.main,
  },
  shortDescription: {
    lineHeight: "1",
  },
  contractInfo: {
    display: "flex",
    flexFlow: "column",
    alignItems: "start",
    gap: theme.spacing(1),
  },
  contractInfoItem: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    margin: "0px",
    gap: theme.spacing(1),
  },

  contractInfoItemInner: {
    display: "flex",
    alignItems: "center",
  },
  coinImage: {
    width: "20px",
    marginLeft: theme.spacing(1),
  },
  buttons: {
    marginTop: theme.spacing(1),
    borderRadius: "14px",
    width: "100%",
  },
}));

ContractButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default function ContractButton({ onClick, info, network }) {
  const classes = useStyles();
  const [iconImage] = useIcon();

  // const [totalInvest, setTotalInvest] = useState(0);
  // const [balance, setBalance] = useState(0);

  // const convertAmount = (amount, decimals) => {
  //   return amount / Number(`1e${decimals}`);
  // };

  // useEffect(() => {
  //   getTotalInvest(info.contractAddress).then((data) => {
  //     setTotalInvest(data);
  //   });

  //   getBalanceAndSymbol(
  //     info.contractAddress,
  //     info.coinIn.address,
  //     network.wethAddress,
  //     [info.coinIn]
  //   ).then((data) => {
  //     setBalance(data.balance);
  //   });
  // }, []);

  return (
    <Paper elevation={0} className={classes.paperContainer}>
      <div className={classes.itemHeader}>
        <div className={classes.imageHolder}>
          <img
            src={info.image}
            alt={info.name}
            className={classes.imageHolderInner}
          />
        </div>

        <div className="d-flex flex-column">
          <Typography variant="body1" className={classes.itemName}>
            {info.name}
          </Typography>

          <Typography variant="caption" className={classes.shortDescription}>
            {info.shortDescription}
          </Typography>
        </div>
      </div>

      <div className={classes.contractInfo}>
        <p className={classes.contractInfoItem}>
          Coin In:{" "}
          <span className={classes.contractInfoItemInner}>
            {info.coinIn.abbr}
            <img
              src={iconImage(info.coinIn.abbr)}
              alt={info.coinIn.abbr}
              className={classes.coinImage}
            />
          </span>
        </p>

        <p className={classes.contractInfoItem}>
          Coin Out:{" "}
          <span className={classes.contractInfoItemInner}>
            {info.coinOut.abbr}
            <img
              src={iconImage(info.coinOut.abbr)}
              alt={info.coinOut.abbr}
              className={classes.coinImage}
            />
          </span>
        </p>

        <p className={classes.contractInfoItem}>
          Annual Percentage Yield (APY):{" "}
          <span className={classes.contractInfoItemInner}>
            {info.annualInterestRate}% {info.coinIn.abbr}
            <img
              src={iconImage(info.coinIn.abbr)}
              alt={info.coinIn.abbr}
              className={classes.coinImage}
            />
          </span>
        </p>

        {/* <p className={classes.contractInfoItem}>
          Total Value Locked (TVL):{" "}
          <span className={classes.contractInfoItemInner}>
            {convertAmount(+totalInvest, info.coinIn.decimals)}{" "}
            {info.coinIn.abbr}
            <img
              src={iconImage(info.coinIn.abbr)}
              alt={info.coinIn.abbr}
              className={classes.coinImage}
            />
          </span>
        </p>

        <p className={classes.contractInfoItem}>
          Contract Balance:{" "}
          <span className={classes.contractInfoItemInner}>
            {balance} {info.coinIn.abbr}
            <img
              src={iconImage(info.coinIn.abbr)}
              alt={info.coinIn.abbr}
              className={classes.coinImage}
            />
          </span>
        </p> */}

        <p className={classes.contractInfoItem}>
          Invest Fee:
          <span className={classes.contractInfoItemInner}>
            {info.investFeeETH / 1e18} {network?.coins[0]?.abbr}
            {network?.coins[0]?.abbr && (
              <img
                src={iconImage(network?.coins[0]?.abbr)}
                alt={network?.coins[0]?.abbr}
                className={classes.coinImage}
              />
            )}
          </span>
        </p>

        <p className={classes.contractInfoItem}>
          Referral Commission Rate:{" "}
          <span className={classes.contractInfoItemInner}>
            {info.referralCommissionRate}%
          </span>
        </p>

        <p className={classes.contractInfoItem}>
          Early Withdraw Penalty:{" "}
          <span className={classes.contractInfoItemInner}>
            {info.earlyRedeemPenaltyRate}%
          </span>
        </p>

        <p className={classes.contractInfoItem}>
          Withdraw Delay:{" "}
          <span className={classes.contractInfoItemInner}>
            {info.withdrawDelay / 3600 / 24} Days
          </span>
        </p>

        <p className={classes.contractInfoItem}>
          Harvest Delay:{" "}
          <span className={classes.contractInfoItemInner}>
            {info.minimumInvestmentPeriod / 3600 / 24} Days
          </span>
        </p>
      </div>

      <Button
        size="large"
        variant="outlined"
        color="primary"
        className={classes.buttons}
        onClick={() => onClick(info)}
      >
        Select
      </Button>

      {info.isNew && <div className="label-badge is-new-badge">New</div>}

      {info.disabled && (
        <div className="label-badge disable-badge">Disabled</div>
      )}
    </Paper>
  );
}
